var map = {
	"./account-sets-blue.svg": "c924",
	"./account-sets-gray.svg": "5a43",
	"./account-sets-white.svg": "841d",
	"./all-blue.svg": "7947",
	"./all-gray.svg": "50a2",
	"./all-white.svg": "a6cb",
	"./escrows-blue.svg": "0188",
	"./escrows-gray.svg": "6fb0",
	"./escrows-white.svg": "5c62",
	"./nfts-blue.svg": "e51f",
	"./nfts-gray.svg": "f273",
	"./nfts-white.svg": "58d9",
	"./offers-blue.svg": "cb6c",
	"./offers-gray.svg": "c073",
	"./offers-white.svg": "7f5a",
	"./payment-channels-blue.svg": "cc5b",
	"./payment-channels-gray.svg": "df0e",
	"./payment-channels-white.svg": "66f9",
	"./payments-blue.svg": "af47",
	"./payments-gray.svg": "9b19",
	"./payments-white.svg": "8666",
	"./trust-lines-blue.svg": "abde",
	"./trust-lines-gray.svg": "7c3b",
	"./trust-lines-white.svg": "544f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ea9";